interface FancyCheckboxProps {
  isChecked: boolean;
  onClick: any;
  title?: string;
  size?: number | string;
}

export const FancyCheckbox = ({
  isChecked,
  onClick,
  title = 'Click to check',
  size = 36,
}: FancyCheckboxProps) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;
  // Intentional, prevent holding down enter / space to click
  const preventClick = (e: any) => {
    if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
      e.preventDefault();
    }
  };
  return (
    <button
      className={`fancy-checkbox${isChecked ? ' checked' : ''}`}
      onKeyDown={preventClick}
      onKeyUp={preventClick}
      onClick={onClick}
      title={title}
      style={{ ['--size' as any]: sizeValue }}
      // Intentional, prevent key events
      tabIndex={-1}
    >
      {isChecked && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="60%" height="60%">
          <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
        </svg>
      )}
    </button>
  );
};
